import OnboardingProfileModal from "./OnboardingProfileModal";

export default OnboardingProfileModal;
